/* JavaScript File                                                  */
/* event-hashtag.js                                                 */
/* Modified Oct 1, 2020                                             */


var event_hashtag = (function(document, window) {

	var evt = [

		function(document, window) {

			var toggle = document.querySelectorAll('[data-toggle=navigate]');

			toggle.forEach(function(button){

				button.addEventListener('click', function(e){
					e.preventDefault();

					if(button){
						
						if(button.href.split('#')[1] != '') {
						
							if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') || location.hostname === this.hostname) {
	
								var href = button.getAttribute('href');
								var offsetTop = document.querySelector(href).offsetTop + 100;
	
								window.scroll({
									top: offsetTop,
									behavior: 'smooth'
								});	
								
							}
	
						}

					}

				}, false);
			});

			// navigation get height

			var nav = document.querySelector('.navigation');
			
			if(nav) {

				var navHeight = nav.offsetHeight + 20;
	
				nav.nextElementSibling.style.marginTop = -navHeight+'px';
			}

		}

	],
	initAll = function() {

		initEvt(document, window);
	},
	initEvt = function(document, window) {

		evt.forEach(function(e) {
			
			e(document, window);
		});
	};
	
	return { init: initAll };

})(document, window);

event_hashtag.init();

window.addEventListener("resize", function(){
	event_hashtag.init();
})

